var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualifying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Qualifying icon",
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25a3.75 3.75 0 10-6.25 2.787v4.713l2.5-1.183 2.5 1.183v-4.713a3.737 3.737 0 001.25-2.787zm-2.5 5.525L15 16.183l-1.25.592v-1.994a3.68 3.68 0 002.5 0v1.994zM15 13.75a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM10 8.75H5.625V10H10V8.75zM11.875 5h-6.25v1.25h6.25V5z",
    fill: "#0A5A67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.75A1.251 1.251 0 012.5 17.5v-15a1.251 1.251 0 011.25-1.25h10A1.251 1.251 0 0115 2.5V5h-1.25V2.5h-10v15H10v1.25H3.75z",
    fill: "#0A5A67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifying);
export default __webpack_public_path__ + "static/media/qualifying.3120fdfe.svg";
export { ForwardRef as ReactComponent };